<template>
    <div>
        <card-header icon="fa-notes">
            <template #title>
                Notes
            </template>
        </card-header>

        <card-toolbar>
            <button @click="$openCard('new-plan-note', {planId: props.planId, userId: props.userId}, card)"><i class="far fa-message-plus"></i>New Note</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <plan-note-tile :note="note" :card="card" v-for="note in notes"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import async from "async";
    import DataRow from "../../TIER/components/DataRow";
    import PlanNoteTile from "../../components/tiles/PlanNoteTile.vue";

    export default {
        components: {PlanNoteTile, DataRow, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                notes: []
            };
        },
        methods: {
            loadPlan: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('payment-plans/' + this.props.planId, {force: true}).then(response => {
                            this.notes = response.data.payment_plan_notes;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.loadPlan();
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
